import { InputLabelProps, SxProps, TextField, Theme } from '@mui/material';
import { useRef } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

interface IProps {
  label?: string;
  select?: boolean;
  children?: React.ReactNode;
  defaultValue?: string | number | boolean;
  value?: string | number | boolean;
  type?: React.HTMLInputTypeAttribute | undefined;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  InputLabelProps?: Partial<InputLabelProps>;
  maxLength?: number;
  required?: boolean;
  register?: UseFormRegisterReturn;
  error?: boolean;
  helperText?: string;
  step?: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  textAlign?: 'left' | 'right' | 'center';
  placeholder?: string;
  placeholderColor?: string;
  variant?: 'outlined' | 'standard';
  size?: 'small' | 'medium';
}

export function FSTextField({
  label,
  select,
  children,
  defaultValue,
  value,
  type,
  disabled,
  sx,
  InputLabelProps,
  maxLength,
  required,
  register,
  error,
  helperText,
  step,
  onChange,
  onBlur,
  textAlign = 'left',
  placeholder,
  placeholderColor,
  variant = 'outlined',
  size = 'medium',
}: IProps) {
  const inputReference = useRef<HTMLInputElement>(null);

  const focusInput = () => {
    inputReference.current?.focus();
  };

  return (
    <TextField
      type={type}
      variant={variant}
      label={label}
      size={size}
      disabled={disabled}
      placeholder={placeholder}
      sx={{
        my: 1,
        width: '100%',
        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
          {
            display: 'none',
          },
        '& input[type=number]': {
          MozAppearance: 'textfield',
        },
        ...sx,
      }}
      InputLabelProps={{
        ...InputLabelProps,
      }}
      inputProps={{
        maxLength,
        step,
        style: {
          textAlign,
        },
        sx: {
          '&::placeholder': {
            color: placeholderColor,
            opacity: 1, // otherwise firefox shows a lighter color
          },
        },
      }}
      // InputProps={{ disableUnderline: variant === 'standard' }}
      select={select}
      defaultValue={defaultValue}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      required={!!required}
      {...register}
      error={error}
      helperText={helperText}
      inputRef={inputReference}
      onInput={focusInput}
    >
      {children}
    </TextField>
  );
}
